import { render, staticRenderFns } from "./ModalSelecaoTipoAssinatura.vue?vue&type=template&id=1b73e0f2&scoped=true"
import script from "./ModalSelecaoTipoAssinatura.vue?vue&type=script&lang=js"
export * from "./ModalSelecaoTipoAssinatura.vue?vue&type=script&lang=js"
import style0 from "./ModalSelecaoTipoAssinatura.vue?vue&type=style&index=0&id=1b73e0f2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b73e0f2",
  null
  
)

export default component.exports